import ServicePage from "../../components/sections/ServicePage";
import React from "react";
import {useTranslation} from "react-i18next";
import HomeInclude from "../../components/sections/HomeInclude";

const WebApplicationDevelopment = () => {
  const {t} = useTranslation();
  const lang = (key) => t(`webApplicationDevelopmentPage.${key}`);
  return (
    <div>
      <ServicePage serviceKey={"web"}/>
      <div className="w-mobile-container md:w-theme-container mx-auto  bg-white text-gray-800">
        <HomeInclude/>
        {/* TECHNOLOGIES */}
        <section className="py-32 px-6 lg:px-20">
          <div className="text-center">
            <h2 className="text-4xl font-bold mb-10">{lang('techWeUse')}</h2>
            <p className="text-gray-600 max-w-3xl mx-auto mb-16">
              {lang('weCanAccept')}
            </p>

            <div className="grid md:grid-cols-3 gap-10">
              {[
                {
                  title: lang('frontendDevelopment'),
                  desc: lang('reactNextJS'),
                  img: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
                },
                {
                  title: lang('backendDev'),
                  desc: lang('dotNetNodeJs'),
                  img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
                },
                {
                  title: lang('database'),
                  desc: lang('mysqlPostql'),
                  img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
                >
                  <img src={item.img} alt={item.title} className="h-56 w-full object-cover" />
                  <div className="p-6">
                    <h3 className="text-2xl font-semibold mb-4">{item.title}</h3>
                    <p className="text-gray-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* SERVICES SECTION */}
        <section className="py-32 px-6 lg:px-20 bg-indigo-50 rounded-xl mt-10">
          <div className="">
            <h2 className="text-4xl font-bold text-center mb-16">{lang('whatWeProvide')}</h2>
            <div className="grid lg:grid-cols-2 gap-20">
              <div>
                <h3 className="text-2xl font-semibold mb-6">{lang('customWebApplications')}</h3>
                <p className="text-gray-600 mb-6">{lang('fromStartup')}</p>

                <h3 className="text-2xl font-semibold mb-6">{lang('saasPlatform')}</h3>
                <p className="text-gray-600 mb-6">{lang('subscriptionBase')}</p>

                <h3 className="text-2xl font-semibold mb-6">{lang('apiDevelopment')}</h3>
                <p className="text-gray-600">{lang('secureRest')}</p>
              </div>
              <img
                src="https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Development Process"
                className="rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </section>
        {/* WHY CHOOSE US */}
        <section className="py-36 px-6 lg:px-20 bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-xl mt-10">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-16">{lang('whyChoose')}</h2>
            <div className="grid md:grid-cols-3 gap-12">
              <div>
                <h3 className="text-2xl font-semibold mb-4">{lang('agileFlex')}</h3>
                <p className="text-gray-300">{lang('weAdaptQuickly')}</p>
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-4">{lang('modernArche')}</h3>
                <p className="text-gray-300">{lang('weUseScalable')}</p>
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-4">{lang('longTerm')}</h3>
                <p className="text-gray-300">{lang('evenIf')}</p>
              </div>
            </div>
          </div>
        </section>
        {/* PROCESS TIMELINE */}
        <section className="py-10 px-6 lg:px-20 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center mb-20">{lang('ourDevelopemt')}</h2>
            <div className="space-y-16">
              {[
                lang('discoveryCon'),
                lang('planningArch'),
                lang('uiUxPrototype'),
                lang('developmentSprint'),
                lang('testingOptimization'),
                lang('deploymentContinuous'),
              ].map((step, index) => (
                <div key={index} className="flex items-center gap-8">
                  <div className="w-16 h-16 flex items-center justify-center bg-theme-color text-white rounded-full text-xl font-bold">
                    {index + 1}
                  </div>
                  <h3 className="text-2xl font-semibold">{step}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* FINAL CTA */}
        <section className="py-14 px-6 lg:px-20 bg-theme-color text-white text-center rounded-xl my-14">
          <h2 className="text-5xl font-bold mb-8">{lang('letBuild')}</h2>
          <p className="text-lg text-gray-200 max-w-2xl mx-auto mb-12">{lang('weMayBe')}</p>
        </section>
      </div>
    </div>
  );
};

export default WebApplicationDevelopment;
